export default {
  title: '我的发布',
  menu: '',
  label: {
    open: '进行中',
    finished: '已完成',
    all: '全部',
    publishing: '发布中',
    taskDate: '任务时间',
    postStatus: '发布状态',
    job: '职位',
    jobAffiliatedCompany: '职位所属公司',
    jobCloseDate: '职位关闭日期',
    taskFinishDate: '任务完成时间',
    postChannel: '发布渠道',
    action: '行为'
  },
  placeholder: {
    searchJobTitle: '通过职位名称搜索',
    thirdPartyJobLink: '第三方职位链接'
  },
  message: {
  }
}
